import React from 'react';

const LocationFilledIcon = ({ width = '24', height = '24' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mdi:location">
        <path
          id="Vector"
          d="M11.5833 11.4596C10.865 11.4596 10.1762 11.1743 9.66825 10.6664C9.16034 10.1585 8.875 9.4696 8.875
          8.7513C8.875 8.03301 9.16034 7.34413 9.66825 6.83622C10.1762 6.32831 10.865 6.04297 11.5833
          6.04297C12.3016 6.04297 12.9905 6.32831 13.4984 6.83622C14.0063 7.34413 14.2917 8.03301 14.2917
          8.7513C14.2917 9.10697 14.2216 9.45915 14.0855 9.78774C13.9494 10.1163 13.7499 10.4149 13.4984
          10.6664C13.2469 10.9179 12.9484 11.1174 12.6198 11.2535C12.2912 11.3896 11.939 11.4596 11.5833
          11.4596ZM11.5833 1.16797C9.57211 1.16797 7.64326 1.96692 6.22111 3.38908C4.79896 4.81123 4 6.74008 4
          8.7513C4 14.4388 11.5833 22.8346 11.5833 22.8346C11.5833 22.8346 19.1667 14.4388 19.1667 8.7513C19.1667
          6.74008 18.3677 4.81123 16.9456 3.38908C15.5234 1.96692 13.5946 1.16797 11.5833 1.16797Z"
          fill="#003B58"
        />
      </g>
    </svg>
  );
};

export default LocationFilledIcon;
